var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resultTaipeiPASS modal-alert"},[_c('t-pass-msg',{ref:"tPassMsg"}),_c('t-pass-directions',{ref:"tPassDirections",attrs:{"content":_vm.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }